import { Injectable } from '@angular/core';
import { VtFormElement } from '@shared/dv-form/interfaces/form.element';
import { VippsMerchantDto } from './interfaces';
import { VtNumberInputElement } from '@shared/dv-form/interfaces/number-input.element';
import { DvSpaceElement } from '@devinco/ui/dds';
import { Validators } from '@angular/forms';
import { VtCheckboxElement } from '@shared/dv-form/interfaces/checkbox.element';

@Injectable({ providedIn: 'root' })
export class VippsIntegrationFormService {
  getElements = (): VtFormElement<VippsMerchantDto>[] => [
    new VtNumberInputElement({
      formControlParams: {
        key: 'MerchantSerialNumber',
        validators: [Validators.required],
      },
      labelText: 'VippsIntegration.MerchantSerialNumber',
      elementParams: { fieldMask: { decimalDigits: 0, thousandSeparator: '' } },
      colspan: 4,
    }),
    new DvSpaceElement({ colspan: 8 }),
    new VtCheckboxElement({
      formControlParams: { key: 'Active' },
      colspan: 12,
      labelText: 'VippsIntegration.IsActive',
      elementParams: { checkboxLabel: '' },
    }),
    new VtNumberInputElement({
      hide: true,
      formControlParams: { key: 'VippsMerchantID' },
    }),
  ];
}
